//const Backofficebff         : string = "/backofficebff/service/api/v1";
//const BackofficebffV2         : string = "/backofficebff/service/api/v2";
const Backofficebff: any = import.meta.env.VITE_BACKOFFICEBFF!;

export const MobilePanelConfigurationQuery: any = {
    GetListMobileConfiguration: Backofficebff + '/v1/mobilpanelconfiguration/listofconfiguration',
    GetListMobileConfigurationV2: Backofficebff + '/v2/mobilepanel/configuration-list',
};
